module.exports = __webpack_public_path__ + "static/one-percent-apply_bg_m-df33c4861c5df027ba92db880c072d6b.png";